import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-catalogacion',
  templateUrl: './catalogacion.component.html',
  styleUrls: ['./catalogacion.component.css']
})
export class CatalogacionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
